<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="支付单号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.payOrderNo" placeholder="请输入支付单号"></el-input>
					</el-form-item>

					<el-form-item label="店铺名称" v-if="!storeFlage">
						<!-- <el-select v-model="searchInfo.storeId" filterable 
							:remote-method="remoteMethod" :loading="storeLoading" remote
							reserve-keyword placeholder="请选择" >
							<el-option v-for="item in storeList" :key="item.id" :value="item.id"
								:label="item.storeName">
							</el-option>
						</el-select> -->
							<el-input style="width: 200px;" v-model="searchInfo.storeName" placeholder="请输入店铺名称"></el-input>
					</el-form-item> 
					
					
                    <el-form-item label="UID" class='tiny'>
						<el-input style="width: 120px;" v-model="searchInfo.uId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					
					<el-form-item label="账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户账号"></el-input>
					</el-form-item>
                    <el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户手机号"></el-input>
					</el-form-item>
					
                    <el-form-item label="支付状态" class='tiny'>
						<el-select v-model="searchInfo.status" placeholder="请选择" >
							<el-option key="-1" label="全部" :value="null">全部</el-option>

							<el-option key="0" label="未支付" value="0"></el-option>
							<el-option key="1" label="已支付" value="1"></el-option>
                            <el-option key="9" label="已取消" value="9"></el-option>
						</el-select>
					</el-form-item> 

					<el-form-item label="支付方式" class='tiny'>
						<el-select v-model="searchInfo.payType"  placeholder="请选择" clear>

							<el-option label="全部"  :value="null" ></el-option>

							<el-option label="积分支付"  value="integral" ></el-option>
							<el-option label="微信支付"  value="wx" ></el-option>
							<el-option label="支付宝支付"  value="alipay" ></el-option>
							<el-option label="微信混合支付"  value="wxplural" ></el-option>
							<el-option label="支付宝混合支付"  value="aliplural" ></el-option>
						</el-select>
					</el-form-item>

                    <el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
        <div style="padding: 0px 0 20px 20px">
            笔数: {{allData.count}} ,
			<span style="margin: 0 20px;">汇总金额: ￥{{allData.amountTotal}} ,</span>
			让利总额: ￥{{allData.amount}} 
        </div>
		<el-table class="tables" :data="userRecordList.list" stripe style="width: 100%;" border
			:header-cell-style="headClass" v-loading="loading" element-loading-text="拼命加载中"
			element-loading-spinner="el-icon-loading">
            <!-- <el-table-column prop="payOrderNo" label="支付单号" align="center" :formatter="changeNull" width="">
			</el-table-column>  -->

			<el-table-column prop="storeName" label="店铺名称" align="center"  v-if="!storeFlage" width="">
				<template slot-scope="scope">
					<p v-if="scope.row.storeName">{{ scope.row.storeName }}</p>
					<p v-else>平台</p>
				</template>
				<!-- 商家不可看 -->
			</el-table-column>
			
			<!-- <el-table-column prop="storeUid" label="店铺所属用户ID" align="center" width="130" v-if="!storeFlage"></el-table-column> -->
			<el-table-column prop="storeType" label="店铺类型" align="center" width="100" v-if="!storeFlage">
                <template slot-scope="scope">
					<p v-if="scope.row.storeType==0">线上店铺</p>
					<p v-if="scope.row.storeType==1">线下门店</p>
				</template>
				<!-- 商家不可看 -->
            </el-table-column>
			<el-table-column prop="" label="付款用户" align="center" width="">
				<template slot-scope="scope">
					<span>{{scope.row.uid}}</span>
					<span v-if="scope.row.username">~{{scope.row.username}}</span>
					<span v-if="scope.row.phone">~{{scope.row.phone}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="paymentAmount" label="实际支付金额" align="center" :formatter="changeNull" width="120">
			</el-table-column> 
            <el-table-column prop="amount" label="支付金额" align="center" :formatter="changeNull" width="100">
			</el-table-column> 
			<el-table-column prop="pv" label="让利比例" align="center" :formatter="changeNull" width="80"></el-table-column>
			
			<el-table-column prop="status" label="支付状态" align="center"  width="80" :formatter="changeNull">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0" style="color:#E6A23C;">未支付</p>
					<p v-if="scope.row.status==1" style="color:#67C23A;">已支付</p>
                    <p v-if="scope.row.status==9" style="color:#F56C6C;">已取消</p>
				</template>
			</el-table-column> 
            <!-- <el-table-column prop="rewardStatus" label="奖励处理状态" align="center"  width="130" :formatter="changeNull">
				<template slot-scope="scope">
					<p v-if="scope.row.rewardStatus==0">待处理</p>
					<p v-if="scope.row.rewardStatus==1">已处理</p>
				</template>
			</el-table-column> -->
            <el-table-column prop="payOrderNo" label="支付单号" align="center"  :show-overflow-tooltip="true" width="">
			</el-table-column>
            <!-- <el-table-column prop="payType" label="支付类型" align="center"  :show-overflow-tooltip="true" width="120">
                <template slot-scope="scope">
					<p v-if="scope.row.payType=='integral'">积分支付</p>
					<p v-if="scope.row.payType=='wx'">微信支付</p>
					<p v-if="scope.row.payType=='alipay'">支付宝支付</p>
					<p v-if="scope.row.payType=='wxplural'">微信混合支付</p>
					<p v-if="scope.row.payType=='aliplural'">支付宝混合支付</p>
				</template>
            </el-table-column>  -->
            <el-table-column prop="" label="支付方式" align="center"  width="">
                <template slot-scope="scope">
					<p v-if="scope.row.payType=='integral'">
                        {{scope.row.integralName}}{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}:{{scope.row.integralNum}}个
                    </p>
					<p v-if="scope.row.payType=='wx'">微信:￥{{ scope.row.cashNum }}</p>
					<p v-if="scope.row.payType=='alipay'">支付宝:￥{{ scope.row.cashNum }}</p>
					<p v-if="scope.row.payType=='wxplural'">
                        {{scope.row.integralName}}{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}:{{scope.row.integralNum}}个，微信:￥{{ scope.row.cashNum }}
                    </p>
					<p v-if="scope.row.payType=='aliplural'">
                        {{scope.row.integralName}}{{scope.row.integralPrice!=1?'(￥'+scope.row.integralPrice+'/个)':''}}:{{scope.row.integralNum}}个，支付宝:￥{{ scope.row.cashNum }}
                    </p>
				</template>
            </el-table-column>
			<el-table-column prop="createTime" label="创建时间" width="" align="center" :show-overflow-tooltip="true" >
			</el-table-column>
		</el-table>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<el-pagination style="margin: 20px;" background :current-page="userRecordList.pageNum"
				@current-change="pageChange" @size-change="handleSizeChange"
				layout="total, sizes, prev, pager, next, jumper" :total="userRecordList.total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import moment from 'moment'; 

	export default {
		data() {
			return {
				loading: false,
				userRecordList: {}, //用户列表
				dialogVisible: false,
				typeList: [],
				integralList: [],
				integralId: "", //积分id
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {
					status: null,
					payType: null,
					timer: []
				},
				allData: {},

				storeFlage: false,

				storeList: [],
				storeLoading: false,
			};
		},
		filters: {
			intToFloatfour(val) {
				return (Math.floor(Number(val) * 10000) / 10000).toFixed(4)
			},
			cutZero(old) {
				//拷贝一份 返回去掉零的新串
				old = old + ""
				var newstr = old
				//循环变量 小数部分长度
				var i = 0
				var leng = old.length - old.indexOf(".") - 1
				//判断是否有效数
				if (old.indexOf(".") > -1) {
					//循环小数部分
					for (i = leng; i > 0; i--) {
						//如果newstr末尾有0
						if (newstr.lastIndexOf("0") > -1 && newstr.substr(newstr.length - 1, 1) == 0) {
							var k = newstr.lastIndexOf("0")
							//如果小数点后只有一个0 去掉小数点
							if (newstr.charAt(k - 1) == ".") {
								return newstr.substring(0, k - 1)
							} else {
								//否则 去掉一个0
								newstr = newstr.substring(0, k)
							}
						} else {
							//如果末尾没有0
							return newstr
						}
					}
				}
				return old
			}

		},
		methods: {
			timelist(){
				var arr=[]
				// var date = new Date();
				// //年 getFullYear()：四位数字返回年份
				// var year = date.getFullYear();  //getFullYear()代替getYear()
				// //月 getMonth()：0 ~ 11
				// var month = date.getMonth() + 1;
				// //日 getDate()：(1 ~ 31)
				// var day = date.getDate();
				// //时 getHours()：(0 ~ 23)
				// var hour = date.getHours();
				// //分 getMinutes()： (0 ~ 59)
				// var minute = date.getMinutes();
				// //秒 getSeconds()：(0 ~ 59)
				// var second = date.getSeconds();
							
				// var time =+ year + '-' + month + '-' + day + ' ' + '00:00:00';
				// var time1 =+ year + '-' + month + '-' + day + ' ' + '23:59:59';
				let time = moment().format('YYYY-MM-DD') + ' ' + '00:00:00';
				let time1 = moment().format('YYYY-MM-DD') + ' ' + '23:59:59';
				// console.log(time1);
				arr.unshift(time1)
				arr.unshift(time)
				return arr
			},
			//导出
			downloadFile() {
				let data = {
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : time,
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : time1,
					username: this.searchInfo.username,
					userId: this.searchInfo.userId,
					fromUserId: this.searchInfo.fromUserId,
					fromUsername: this.searchInfo.fromUsername,
					changeType: this.searchInfo.changeType,
					// phone: this.searchInfo.phone,
					// intergralId: this.searchInfo.integralId,
					// source: this.searchInfo.type
				};
				//   console.log(data);				
				if (data.startTime || data.endTime) {
					this.$api.assetChangesExcel(data).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
				} else {
					this.$message.error('请选择时间')
				}
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "资产变动记录" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserRecordList();
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserRecordList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserRecordList()
			},
			
			getUserRecordList() {
				this.loading = true
				// let date = new Date();
				// //年 getFullYear()：四位数字返回年份
				// let year = date.getFullYear();  //getFullYear()代替getYear()
				// //月 getMonth()：0 ~ 11
				// let month = date.getMonth() + 1;
				// //日 getDate()：(1 ~ 31)
				// let day = date.getDate();
				// //时 getHours()：(0 ~ 23)
				// let hour = date.getHours();
				// //分 getMinutes()： (0 ~ 59)
				// let minute = date.getMinutes();
				// //秒 getSeconds()：(0 ~ 59)
				// let second = date.getSeconds();
			
				// let time =+ year + '-' + month + '-' + day + ' ' + '00:00:00';
				// let time1 =+ year + '-' + month + '-' + day + ' ' + '23:59:59';
					// console.log(time1);
				let time = moment().format('YYYY-MM-DD') + ' ' + '00:00:00';
				let time1 = moment().format('YYYY-MM-DD') + ' ' + '23:59:59';

				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,

					startTime: this.searchInfo.timer ? this.searchInfo.timer[0]:'',
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1]:'',
					username: this.searchInfo.username,
					uid: this.searchInfo.uId,
					phone: this.searchInfo.phone,
                    storeId: this.searchInfo.storeId,
                    storeName: this.searchInfo.storeName,
                    status: this.searchInfo.status,
					payType: this.searchInfo.payType,

					payOrderNo: this.searchInfo.payOrderNo
				}
				this.$api.getPaymentByCodeList(data).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					// console.log('六十六大神了--', res.data)
					if (res.state == 'success') {
						this.userRecordList = res.data
						this.loading = false
					} else {
						this.$message.error(res.message)
					}
				})
				this.$api.getPaymentByCodeSum(data).then((res) => {
					// res=JSON.parse(this.$decrypt(res.data))
					if (res.state == 'success') {
                        console.log('统计---', res.data)
						this.allData = res.data
					}
				})
			},
			getRecordTypeList() {
				let data = {}
				this.$api.getRecordTypeList(this.$encrypt(data)).then((res) => {
					res=JSON.parse(this.$decrypt(res.data))
					// console.log('数据---',res )
					if (res.state == 'success') {
						this.typeList = res.data
					}
				})
			},
			useeInfo(){
				this.$api.getUserInfo(this.$encrypt({})).then((res) => {
					// console.log('登录数据1---', res.data)
					res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('登录数据2---', res.data)
					if (res.state == 'success') {

						// storeId //不为0是店铺
						// this.storeInfo = res.data.store
						this.storeFlage = res.data.storeId==0?false:true;
					}
				})
			},
			remoteMethod(query) {
				if (query.length >= 2) {
					this.storeLoading = true;
					setTimeout(() => {
						let data = {
							storeName: query,
						}
						this.$api.getStoreNameList(data).then((res) => { //店铺管理
							if (res.state == 'success') {
								this.storeList = res.data;
							} else {
								this.$message.error(res.message);
							}
						})
						this.storeLoading = false;
					}, 200);
				} else {
					this.storeList = [];
				}
			},
		},
		created() {
			// console.log(this.timelist());
			this.getUserRecordList();
			this.useeInfo();
			// this.getRecordTypeList();
			// this.$api.getIntegralListTwo().then((res) => {
			// 	// res=JSON.parse(this.$decrypt(res.data))
			// 	if (res.state == 'success') {
			// 		this.integralList = res.data
			// 	}
			// })
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
